import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/navigation";
import { useIsMobile } from "@/hooks/use-mobile";
import { ModalTypeEnum, useModal } from "@/components/providers/modal-provider/ModalProvider";
import { ROUTE_PATHS } from "@/constants/routes";
import { NewRealEstateManagement } from "../components/new-real-estate-management.tsx/NewRealEstateManagement";
import { useCanCreatePortfolio } from "./useCanCreatePortfolio";
export type AddPortfolioOptions = {
  onCreated?: (portfolioId: string) => void;
  onCancel?: () => void;
};
export function useAddPortfolio() {
  const $ = _c(9);
  const isMobile = useIsMobile();
  const router = useRouter();
  const {
    openModal,
    closeModal
  } = useModal();
  const canCreatePortfolio = useCanCreatePortfolio();
  let t0;
  if ($[0] !== canCreatePortfolio || $[1] !== closeModal || $[2] !== isMobile || $[3] !== openModal || $[4] !== router) {
    t0 = options => {
      const opts = options && typeof options === "object" && ("onCreated" in options || "onCancel" in options) ? options as AddPortfolioOptions : undefined;
      if (canCreatePortfolio) {
        const props = {
          onSubmitSuccess: opts?.onCreated,
          onClose: opts?.onCancel ? () => {
            closeModal();
            opts.onCancel?.();
          } : undefined
        };
        isMobile ? openModal(ModalTypeEnum.GENERIC_SHEET, {
          children: <NewRealEstateManagement {...props} />,
          side: "bottom",
          className: "p-0",
          hasClose: false
        }) : openModal(ModalTypeEnum.GENERIC_DIALOG, {
          children: <NewRealEstateManagement {...props} />,
          childrenClassName: "p-0"
        });
        return;
      }
      router.push(`${ROUTE_PATHS.SUBSCRIPTIONS}?from=properties`);
    };
    $[0] = canCreatePortfolio;
    $[1] = closeModal;
    $[2] = isMobile;
    $[3] = openModal;
    $[4] = router;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const handleAddNewRealEstate = t0;
  let t1;
  if ($[6] !== canCreatePortfolio || $[7] !== handleAddNewRealEstate) {
    t1 = {
      handleAddNewRealEstate,
      canCreatePortfolio
    };
    $[6] = canCreatePortfolio;
    $[7] = handleAddNewRealEstate;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
}